import { useQuery } from '@tanstack/react-query';

import { dashboardRepository } from '../../../lib/repositories/dashboard.repository';
import type { DashboardCounters, KnowledgeBase } from '../../../mock/fixtures';

/** Số đếm toàn hệ cho dashboard. */
export function useDashboardCounters() {
  return useQuery<DashboardCounters>({
    queryKey: ['dashboard', 'counters'],
    queryFn: dashboardRepository.counters,
    staleTime: 60_000,
  });
}

/** Danh sách bộ tri thức, dùng cho ô `Kho tri thức AI` và biểu đồ phòng ban. */
export function useKnowledgeBases() {
  return useQuery<KnowledgeBase[]>({
    queryKey: ['dashboard', 'knowledge-bases'],
    queryFn: dashboardRepository.knowledgeBases,
    staleTime: 60_000,
  });
}
